import types from '../../types';

const deposit = (state = { loading: true, data: null }, { type, payload }) => {
  switch (type) {
    case types.GET_DEPOSITS_START:
      return { ...state, loading: true };

    case types.GET_DEPOSITS_SUCCESS:
      return { ...payload, loading: false };

    case types.GET_DEPOSITS_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default deposit;
